import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { ModalBody } from "reactstrap";

import {
    setDataKitchenTicket,
    setNoteKitchenTicket,
    setTicketKitchenModeSale,
    setKitchenCustomerAddressModeSale as setCustomerAddressModeSale,
    setCustomerInformationModeSaleName,
    setCustomerInformationModeSaleNumTel,
    setCustomerInformationModeSaleAdress,
    setCustomerInformationModeSaleCity,
    setCustomerInformationModeSaleCode,
    setCustomerInformationModeSaleCompany,
    storeKitchenTicketType,
} from "@components/Common/PrinterSetting/stores";

import {
    PrinterRowData,
    PrinterKitchenTicketBlock,
    PrinterAppId,
} from "../../types";
import { SalesModeApiItem } from "../../hooks/salesModesHelper";

import UserCard from "./Hook/UserCard";

import "@assets/swal.css";
import "@assets/theme.css";

import "../index.css";

type KitchenPanelSettingType = {
    rowData: PrinterRowData;
    oneShop: boolean;
    salesModesData: SalesModeApiItem[];
    appId: PrinterAppId;
};

export default function KitchenPanelSetting({
    rowData,
    salesModesData,
    appId,
}: KitchenPanelSettingType) {
    const { t } = useTranslation();
    const {
        ticketKitchenModeSale,
        customerAddressModeSale,
        noteKitchenTicketPrintNote,
        customerInformationModeSaleName,
        customerInformationModeSaleNumTel,
        customerInformationModeSaleCity,
        customerInformationModeSaleAdress,
        customerInformationModeSaleCode,
        customerInformationModeSaleCompany,
    } = useSnapshot(storeKitchenTicketType);
    useEffect(() => {
        const kitchenTicket = rowData["Kitchen_ticket"];
        if (kitchenTicket && typeof kitchenTicket === "object")
            if (Object.keys(kitchenTicket).length > 0) {
                if (kitchenTicket.note_kitchen_ticket) {
                    setNoteKitchenTicket(
                        kitchenTicket.note_kitchen_ticket.print_note
                    );
                }
                if (kitchenTicket.ticketKitchenModeSale) {
                    setTicketKitchenModeSale(
                        kitchenTicket.ticketKitchenModeSale
                    );
                }

                if (kitchenTicket.customerAddressModeSale) {
                    setCustomerAddressModeSale(
                        kitchenTicket.customerAddressModeSale
                    );
                }
                const customerInfo =
                    kitchenTicket.customer_information_mode_sale;
                if (customerInfo.customerInformationModeSaleCity) {
                    setCustomerInformationModeSaleCity(
                        customerInfo.customerInformationModeSaleCity
                    );
                }
                if (customerInfo.customerInformationModeSaleName) {
                    setCustomerInformationModeSaleName(
                        customerInfo.customerInformationModeSaleName
                    );
                }
                if (customerInfo.customerInformationModeSaleNumTel) {
                    setCustomerInformationModeSaleNumTel(
                        customerInfo.customerInformationModeSaleNumTel
                    );
                }
                if (customerInfo.customerInformationModeSaleAdress) {
                    setCustomerInformationModeSaleAdress(
                        customerInfo.customerInformationModeSaleAdress
                    );
                }
                if (customerInfo.customerInformationModeSaleCode) {
                    setCustomerInformationModeSaleCode(
                        customerInfo.customerInformationModeSaleCode
                    );
                }
                if (customerInfo.customerInformationModeSaleCompany) {
                    setCustomerInformationModeSaleCompany(
                        customerInfo.customerInformationModeSaleCompany
                    );
                }
            }
    }, [rowData, rowData?.Kitchen_ticket]);

    useEffect(() => {
        const data: PrinterKitchenTicketBlock = {
            note_kitchen_ticket: {
                print_note: noteKitchenTicketPrintNote,
            },
            ticketKitchenModeSale,
            customerAddressModeSale,
            customer_information_mode_sale: {
                customerInformationModeSaleName,
                customerInformationModeSaleNumTel,
                customerInformationModeSaleCity,
                customerInformationModeSaleAdress,
                customerInformationModeSaleCode,
                customerInformationModeSaleCompany,
            },
        };
        setDataKitchenTicket(data);
    }, [
        noteKitchenTicketPrintNote,
        customerAddressModeSale,
        ticketKitchenModeSale,
        customerInformationModeSaleName,
        customerInformationModeSaleNumTel,
        customerInformationModeSaleCity,
        customerInformationModeSaleAdress,
        customerInformationModeSaleCode,
        customerInformationModeSaleCompany,
    ]);

    return (
        <React.Fragment>
            <ModalBody style={{ height: "730px", overflow: "hidden" }}>
                <div className="pt-2 px-3">
                    <div>
                        <h4 style={{ fontSize: "24px" }}>
                            {t("Kitchen ticket")}
                        </h4>
                    </div>
                </div>
                <UserCard
                    rowData={rowData}
                    salesModesData={salesModesData}
                    appId={appId}
                />
            </ModalBody>
        </React.Fragment>
    );
}
